import React from 'react'

export const GlobalStateContext = React.createContext()
export const GlobalDispatchContext = React.createContext()

const initialState = {
  theme: 'white',
  headroom: null,
  modalIsOpen: false,
}

function reducer(state, action) {
  // console.log(action)

  switch (action.type) {
    case 'setTheme': {
      return {
        ...state,
        theme: action.value,
      }
    }
    case 'setHeadroomStatus': {
      return {
        ...state,
        headroom: action.value,
      }
    }
    default:
      throw new Error('Bad Action Type')
  }
}

const GlobalContextProvider = ({ children }) => {
  const [state, dispatch] = React.useReducer(reducer, initialState)
  return (
    <GlobalStateContext.Provider value={state}>
      <GlobalDispatchContext.Provider value={dispatch}>
        {children}
      </GlobalDispatchContext.Provider>
    </GlobalStateContext.Provider>
  )
}

export default GlobalContextProvider